import { inject, Injectable } from '@angular/core';
import { UserNote} from "../amplify/data-resource";
import { Logger } from 'tslog';
import {Utils} from '../utils/amplify-utils';
import { SelectionSet } from 'aws-amplify/api';
import { AmplifyService } from './amplify.service';

@Injectable({
  providedIn: 'root'
})
export class UserNoteService {
  private log = new Logger({
    name:'UserNoteService',
    minLevel: Utils.GLOBAL_LOG_LEVEL
  });
  

  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();

  public async createOrUpdateUserNote(userId:string, contentId:string, contentNoteId:string, content:string, noteAlias:string, userNoteId?:string): Promise<UserNote>{

    this.log.trace(`createOrUpdateNote`);
    this.log.debug(`contentNoteId:[${contentNoteId}], content:[${content}], userNoteId?:[${userNoteId}]`);

    if(!userNoteId){ //try to find the user note anyways, maybe we got a confusion in the state management?
      userNoteId = await this.findUserNoteIdByContenAndAlias(contentId,userId,noteAlias);
      this.log.warn(`Even though no userNoteId was provided, I have found one in the database. I will update this note instead of creating a new one! `);
    }

    if(userNoteId){
      //Update
    // @ts-ignore
    const updateResult = await this.amplifyClient.models.UserNote.update({id: userNoteId,content:content});
      Utils.handleError(updateResult,(`Error updating user note`));
      if(updateResult.data){return updateResult.data}else{throw Error('undefined result updating user note')};
    }else{
      //Create
        const createResult = await this.amplifyClient.models.UserNote.create({
    // @ts-ignore
    userId:userId,
    // @ts-ignore
    noteId: contentNoteId,
    // @ts-ignore
    contentRefId: contentId,
    // @ts-ignore
    content:content,
        });
        Utils.handleError(createResult,(`Error creating user note`));
        if(createResult.data){return createResult.data}else{throw Error('undefined result creating user note')};
      }
  }

  public async createUserNote(userId:string, contentId:string, contentNoteId:string, noteContents:string): Promise<UserNote|null>{
    const createResult = await this.amplifyClient.models.UserNote.create({
    // @ts-ignore
      userId:userId,
    // @ts-ignore
    noteId: contentNoteId,
    // @ts-ignore
    contentRefId: contentId,
    // @ts-ignore
    content:noteContents,
    });
    const userNote = Utils.getDataFromResult(createResult.data,createResult.errors,'UserNote.create');
    return userNote;
  }

  public async updateUserNote(userNoteId:string,noteContents:string): Promise<boolean>{
    const updateResult = await this.amplifyClient.models.UserNote.update({
      id: userNoteId,
    // @ts-ignore
      content:noteContents,
    });
    const userNote = Utils.getDataFromResult(updateResult.data,updateResult.errors,'UserNote.update');
    return userNote?true:false;
  }

  private async findUserNoteIdByContenAndAlias(contentId:string, userId:string, alias:string):Promise<string|undefined>{
    this.log.trace(`findUserNoteByContenAndAlias`);
    
    const userNotesbyContentAlias = [
      'id',
      'parentNote.alias'] as const;
    type UserNotesbyContentAlias = SelectionSet<UserNote, typeof userNotesbyContentAlias>;
    
    const result = await this.amplifyClient.models.UserNote.listUserNoteByContentRefIdAndUserId(
      {contentRefId: contentId, userId:{eq:userId}},
      { selectionSet: userNotesbyContentAlias }
    );
    Utils.handleError(result,(`Error findUserNoteByContenAndAlias`));
    if(result.data){
      const noteFound = result.data.find(e=>e.parentNote.alias===alias);
      if(noteFound){
        this.log.info(`findUserNoteIdByContenAndAlias contentId=[${contentId}], userId=[${userId}], alias=[${alias}], FOUND [${noteFound.id}]`);
        return noteFound.id;
      }else{
        this.log.info(`findUserNoteIdByContenAndAlias contentId=[${contentId}], userId=[${userId}], alias=[${alias}], NOT FOUND`);
      }
    }
    this.log.info(`findUserNoteIdByContenAndAlias contentId=[${contentId}], userId=[${userId}], alias=[${alias}], UNDEFINED`);
    return undefined;
  }  

  public async deleteUserNote(userNoteId:string){
    this.log.trace(`deleteUserNote`);

    const deleteResult = await this.amplifyClient.models.UserNote.delete({id: userNoteId});
    Utils.handleError(deleteResult,(`Error deleting user note`));
  }  
}
